"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogForm = exports.SubmitButtonWrapper = exports.CustomValidatedSelectInput = exports.CheckboxInputWrap = exports.InputWrapOdd = exports.RadioInputWrap = exports.InputWrap = exports.ValidatedRadioGroupWrap = exports.FormContent = exports.SubmitOrderModalButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_radio_group_1 = require("@hotelplan/components.common.radio-group");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const components_common_select_input_1 = require("@hotelplan/components.common.select-input");
const components_common_privacy_1 = require("@hotelplan/components.common.privacy");
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
exports.SubmitOrderModalButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon)(({ theme }) => (Object.assign(Object.assign(Object.assign({}, theme.buttons.btnWithIcon), theme.catalogs.catalogFormSubmitButton), { '.counter': {
        top: 0,
        right: 0,
        transform: 'translate(-50%, -50%)',
    } })));
exports.FormContent = styled_components_1.default.div(({ theme }) => (Object.assign({}, theme.catalogs.catalogsFormContent)));
exports.ValidatedRadioGroupWrap = (0, styled_components_1.default)(components_common_radio_group_1.ValidatedRadioGroup)((0, util_theme_sxc_1.sx2CssThemeFn)({
    div: {
        display: 'flex',
        flexDirection: 'row',
        py: 2,
    },
    '.label': {
        mr: 4,
        pl: 0,
    },
}));
exports.InputWrap = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    width: ['100%', 'calc(100% / 3)'],
    px: '5px',
    mb: [3, '20px'],
}));
exports.RadioInputWrap = (0, styled_components_1.default)(exports.InputWrap)((0, util_theme_sxc_1.sx2CssThemeFn)({
    mb: [1, 0],
}));
exports.InputWrapOdd = (0, styled_components_1.default)(exports.InputWrap)((0, util_theme_sxc_1.sx2CssThemeFn)({
    mb: [3, 0],
}));
exports.CheckboxInputWrap = (0, styled_components_1.default)(exports.InputWrap)((0, util_theme_sxc_1.sx2CssThemeFn)({
    width: '100%',
    p: '5px',
    mb: [null, '20px'],
    '.label': {
        color: 'initial',
        pl: 0,
    },
}), ({ theme: { space, media } }) => ({
    '.order-catalogs-checkbox': {
        marginBottom: space[3],
        [media.tablet]: {
            marginBottom: space[0],
        },
    },
}));
exports.CustomValidatedSelectInput = (0, styled_components_1.default)(components_common_select_input_1.ValidatedSelectInput)(({ theme }) => (Object.assign({}, theme.forms.customSelectControl)));
exports.SubmitButtonWrapper = (0, styled_components_1.default)(components_common_privacy_1.SubmitWithPrivacyButtonWrapper)(({ theme }) => theme.forms.submitButtonWrapper);
exports.CatalogForm = styled_components_1.default.form(({ theme }) => theme.catalogs.catalogForm);
//# sourceMappingURL=fdr-catalogs-order-form.styles.js.map